module.exports = __webpack_public_path__ + "01_medium_black.882b7671.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_medium_black.png
// module id = bOLv
// module chunks = 0